module.exports = __webpack_public_path__ + "static/img/bg_xlsx.064ab32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_xlsx.png
// module id = GIO2
// module chunks = 1